import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { IconName, IconSize } from '../../../../../components/Atoms/Icon/Icon.enum';
import sendGTMEvent from '../../../../common/analytics/sendGTMEvent';
import { HeaderTrackingElementName } from '../../../../common/analytics/types/header';
import { INITIAL_SUB_PAGE } from '../../constants/InitialMobileSubpage';
import { NavigationRoutes } from '../../constants/navigationRoutes';
import { Icon } from '../../iconsHelper';
import { BadgeNew } from '../Badge/BadgeNew';
import { List, SignUpParagraph, SignUpSection, StyledLink } from './MobileNavigation.styled';
import MobileNavigationItem from './MobileNavigationItem';
import { MobileNavigationTemplate } from './MobileNavigationTemplate/MobileNavigationTemplate';
import { AboutUsSubNavigation } from './SubNavigations/AboutUsSubNavigation';
import { AccessoriesSubNavigation } from './SubNavigations/AccessoriesSubNav';
import { BrowseCollectionsSubNavigation } from './SubNavigations/BrowseCollectionsSubNavigation';
import { FindYourDisplatesSubNavigation } from './SubNavigations/FindYourDisplatesSubNavigation';
import { LimitedDisplatesSubNavigation } from './SubNavigations/LimitedDisplatesSubNavigation';
import { MyAccountSubNavigation } from './SubNavigations/MyAccountSubNavigation';
import { SupportSubNavigation } from './SubNavigations/SupportSubNavigation';
export const MobileNavigation = ({ isMobileNavigationOpen, setIsMobileNavigationOpen, onLogin, onLogout, onSignUp, userNick, accountRoles, }) => {
    const [currentSubNavigation, setCurrentSubNavigation] = useState(INITIAL_SUB_PAGE);
    const closeNavigation = () => setIsMobileNavigationOpen(false);
    const isVisible = (label) => currentSubNavigation === label && isMobileNavigationOpen;
    const handleOnMenuItemClick = (item) => {
        if (item.onClick)
            item.onClick();
    };
    const myAccountNavItem = (nick) => ({
        id: 'my-account',
        label: 'My account',
        subpage: (_jsx(MyAccountSubNavigation, { accountRoles: accountRoles, onLogout: onLogout, userNick: nick }, void 0)),
        onClick: () => {
            sendGTMEvent({
                event: 'menu_item_click',
                element_name: HeaderTrackingElementName.MY_ACCOUNT,
                device_category: 'mobile',
            });
        },
    });
    const navigationItems = [
        ...(userNick ? [myAccountNavItem(userNick)] : []),
        {
            id: 'home',
            url: NavigationRoutes.HOMEPAGE,
            label: 'Home',
        },
        {
            id: 'browse-posters',
            label: 'Browse Posters',
            subpage: _jsx(FindYourDisplatesSubNavigation, {}, void 0),
        },
        {
            id: 'explore-collections',
            label: 'Explore Collections',
            subpage: _jsx(BrowseCollectionsSubNavigation, {}, void 0),
        },
        {
            id: 'discover-brands',
            url: NavigationRoutes.BROWSE_BRANDS,
            label: 'Discover Brands',
        },
        {
            id: 'limited-edition',
            label: 'Limited Displates',
            subpage: _jsx(LimitedDisplatesSubNavigation, {}, void 0),
        },
        {
            id: 'accessories',
            label: 'Accessories & Gifts',
            subpage: _jsx(AccessoriesSubNavigation, {}, void 0),
            badge: _jsx(BadgeNew, {}, void 0),
        },
        {
            id: 'displate-club',
            url: NavigationRoutes.JOIN_DISPLATE_CLUB,
            label: 'Displate Club',
        },
        {
            id: 'whats-displate',
            url: NavigationRoutes.WHATS_DISPLATE,
            label: "What's a Displate",
        },
        {
            id: 'support',
            label: 'Support',
            subpage: _jsx(SupportSubNavigation, {}, void 0),
        },
        {
            id: 'about-us',
            label: 'About Us',
            subpage: _jsx(AboutUsSubNavigation, {}, void 0),
        },
    ];
    return (_jsxs(MobileNavigationTemplate, Object.assign({ closeNavigation: closeNavigation, comeBackToPreviousPage: () => setCurrentSubNavigation(INITIAL_SUB_PAGE), displayedFromLeftSide: true, isVisible: isMobileNavigationOpen }, { children: [!userNick && (_jsxs(SignUpSection, { children: [_jsx(Icon, { height: 22, name: IconName.USER_MENU, size: IconSize.SIZE24 }, void 0), _jsxs(SignUpParagraph, { children: ["Hello!\u00A0", _jsx(StyledLink, Object.assign({ onClick: () => {
                                    sendGTMEvent({
                                        event: 'menu_item_click',
                                        element_name: HeaderTrackingElementName.LOG_IN,
                                        device_category: 'mobile',
                                    });
                                    onLogin && onLogin();
                                } }, { children: "Log in" }), void 0), "\u00A0or\u00A0", _jsx(StyledLink, Object.assign({ href: "/auth/signin/register-user", onClick: () => {
                                    sendGTMEvent({
                                        event: 'menu_item_click',
                                        element_name: HeaderTrackingElementName.SIGN_UP,
                                        device_category: 'mobile',
                                    });
                                    onSignUp && onSignUp();
                                } }, { children: "Sign up" }), void 0)] }, void 0)] }, void 0)), _jsx(List, { children: navigationItems.map((item) => (_jsx(MobileNavigationItem, { closeNavigation: closeNavigation, isMobileNavigationOpen: isMobileNavigationOpen, isVisible: isVisible, navigationItem: item, onItemClick: () => handleOnMenuItemClick(item), setCurrentSubNavigation: setCurrentSubNavigation }, item.id))) }, void 0)] }), void 0));
};
//# sourceMappingURL=MobileNavigation.js.map